//react stuff
import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter as Router} from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { StripeProvider } from 'react-stripe-elements';
import client from './apollo';

import { STRIPE_PUBLISHABLE_KEY } from './consts';

import 'semantic-ui-css/semantic.min.css';

let application = (
  <ApolloProvider client={client}>
    <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
      <Router>
        <App />
      </Router>
    </StripeProvider>
  </ApolloProvider>
)

ReactDOM.render(application, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js